export default __webpack_public_path__ + "static/media/ai_color_detectionActive.1a499164.svg";